import React from "react"


function Title(){
    return <div>
        <h1>Requerimento de Declaração de Autenticidade</h1>
        <h2 className="descrição">Insira o código do certificado e o e-mail de destino para que possamos enviar sua declaração!






</h2>
    </div>
}

export default Title


